<template lang="pug">
v-footer(fixed app)
  v-layout(align-center row wrap)
    div.ml-2
      span()
      .text-sm-left
      .footertext &copy; 2018 <strong>Complispace Pty. Ltd.</strong> All Rights Reserved.
    v-spacer
    div.mt-2.mr-2
      a(href="https://www.complispace.com.au" target="_blank")
        img(
          src="../../resources/assets/complispace-logo.png"
          alt="Logo"
        ).footer-logo
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'AppFooter',

    computed: {
        ...mapState({
            footer: state => state.appearance.footer,
            copyright: state => state.app.copyright
        })
    }
};
</script>

<style>
.footer-logo {
  width: 110px;
}

@media (max-width:768px){
  .footertext {
    display:none
  }
}
</style>



// WEBPACK FOOTER //
// src/components/core/AppFooter.vue